import { pageInfo, deleteBatch, exportData, upload, downLoadTemplate, cusExportData, depExportData } from './../api';
const tpDailyDc = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    deleteBatchObj: null,
    exportObj: null,
    uploadObj: null,
    templateObj: null,
    cusExportObj: null,
    depExportObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({ ...item, btns: [true, true] }));
    },
    DELETE_BATCH(state, data) {
      state.deleteBatchObj = data;
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    UPLOAD_DATA(state, data) {
      state.uploadObj = data;
    },
    DOWN_TEMPLATE(state, data) {
      state.templateObj = data;
    },
    CUS_EXPORT_DATA(state, data) {
      state.cusExportObj = data;
    },
    DEP_EXPORT_DATA(state, data) {
      state.depExportObj = data;
    },
  },
  actions: {
    async pageInfo({ commit }, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async deleteBatch({ commit }, obj) {
      let resp = await deleteBatch(obj);
      commit('DELETE_BATCH', resp);
    },
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    async upload({ commit }, obj) {
      let resp = await upload(obj);
      commit('UPLOAD_DATA', resp);
    },
    async downLoadTemplate({ commit }, obj) {
      let resp = await downLoadTemplate(obj);
      commit('DOWN_TEMPLATE', resp);
    },
    async cusExportData({ commit }, obj) {
      let resp = await cusExportData(obj);
      commit('CUS_EXPORT_DATA', resp);
    },
    async depExportData({ commit }, obj) {
      let resp = await depExportData(obj);
      commit('DEP_EXPORT_DATA', resp);
    }
  }
}
export default tpDailyDc



// WEBPACK FOOTER //
// ./src/page/assess/tpDailyDc/store/tpDailyDc.store.js